/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { AddressDTO, PointDtoModel } from '@well/address-management-domain-model';

export class AddressVoModel {
  uuid: string | null = null;

  owner: string | null = null;

  city: string | null = null;

  postalCode: string | null = null;

  addressLine: string | null = null;

  state: string | null = null;

  country: string | null = null;

  pointDTO: PointDtoModel | null = null;

  isPartial: boolean | null = null;

  static mapToAddressDto(addressVO: AddressVoModel | null | undefined): AddressDTO | null {
    if (addressVO) {
      const addressDto = new AddressDTO();
      addressDto.uuid = addressVO.uuid;
      addressDto.owner = addressVO.owner;
      addressDto.city = addressVO.city;
      addressDto.postalCode = addressVO.postalCode;
      addressDto.addressLine = addressVO.addressLine;
      addressDto.state = addressVO.state;
      addressDto.country = addressVO.country;
      addressDto.pointDTO = addressVO.pointDTO;

      return addressDto;
    }
    return null;
  }
}
